
const state = {
  files: [],
  includedFiles: [],
  url: '',
  isPrevious: false
}

const getters = {
  getIsPrevious (state) {
    return state.isPrevious
  },
  getURL (state) {
    return state.url
  },
  getIncludedFiles (state) {
    return state.includedFiles
  },
  getFiles (state) {
    return state.files
  }
}

const mutations = {
  setIncludedFiles (state, data) {
    state.includedFiles = data
  },
  setFiles (state, data) {
    state.files = data
  },
  setURL (state, data) {
    state.url = data
  },
  setIsPrevious (state, data) {
    state.isPrevious = data
  }
}

const actions = {
  setURL (context, data) {
    context.commit('setURL', data)
  },
  setFiles (context, data) {
    context.commit('setFiles', data)
  },
  setIncludedFiles (context, data) {
    context.commit('setIncludedFiles', data)
  },
  setIsPrevious (context, data) {
    context.commit('setIsPrevious', data)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/content.js